<template lang="pug">
.c-panel
  .c-panel__header
    p.u-mts.u-mbs(v-text="message")
  .c-panel__body
    template(v-if="isAlertDialog")
      button.c-btn.c-btn--primary.c-btn--fill(@click="onConfirm")
        span(v-text="options.ok", v-if="options && options.ok")
        span(v-text="'OK'", v-else)
    template(v-else-if="isConfirmDialog")
      .u-flex
        button.c-btn.c-btn--fill.btn.u-mrxs(@click="onCancel")
          span(v-text="options.cancel", v-if="options && options.cancel")
          span(v-text="'Cancel'", v-else)
        button.c-btn.c-btn--primary.c-btn--fill.u-mlxs(@click="onConfirm")
          span(v-text="options.ok", v-if="options && options.ok")
          span(v-text="'OK'", v-else)
</template>

<script>
// plugin形式でvue-js-modalと併用して使用されるので単体では使用できない
export default {
  name: 'modal_dialog',
  props: {
    type: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => {}
    },
    cancelCallback: {
      type: Function
    },
    confirmCallback: {
      type: Function,
      required: true
    }
  },
  computed: {
    isAlertDialog() {
      return this.type === 'alert';
    },
    isConfirmDialog() {
      return this.type === 'confirm';
    }
  },
  created() {
    window.addEventListener('keyup', this.onKeyUp);
  },
  destroyed() {
    window.removeEventListener('keyup', this.onKeyUp);
  },
  methods: {
    onKeyUp(event) {
      if (this.options.clickToClose) {
        return;
      }

      if (event.which === 13) {
        this.onConfirm();
      }
    },
    onCancel() {
      this.cancelCallback();
      this.$emit('close');
    },
    onConfirm() {
      this.confirmCallback();

      if (!(this.options && this.options.noCloseOnConfirm)) {
        this.$emit('close');
      }
    }
  }
};
</script>
